import * as React from "react";
import { InputElementUnion } from "@graffer-inc/form-schema";
import { TenantProcessResultDocument } from "@graffer-inc/cloud-gov-core";
import { SecondaryButton } from "@graffer-inc/console-design-kit";

type TenantProcessResultViewProps = {
  inputElements: InputElementUnion[];
  document: TenantProcessResultDocument;
  editable: boolean;
  startEdit: () => void;
};

export const TenantProcessResultView: React.FC<
  TenantProcessResultViewProps
> = ({ inputElements, document, editable, startEdit }) => {
  return (
    <>
      {inputElements.map((e) => (
        <div className="field" key={e.id}>
          <label className="label">{e.label.text}</label>
          <div className="control">
            <p>{document[e.id]}</p>
          </div>
        </div>
      ))}
      {editable && <SecondaryButton text="修正する" onClick={startEdit} />}
    </>
  );
};
